import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import { Drawer, Row, Col, Button } from 'antd';
import './CustomDrawer.css';

import commonConfig from '../../../commonConfig.json';
let drawerConfigs = commonConfig.drawerProps;

const CustomDrawer = props => {
    const [drawerData, setDrawerData] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);
    
    const processCallBackSections = (type, label, isbtndisable, callback, action) => {
        let splited = type.split("_");
        if (splited[0] === 'button') {
            return (
                <Button
                    key={props.name + "_" + label}
                    type={splited[1] !== undefined ? splited[1] : 'default'}
                    onClick={() => callback({ 
                        visibility: false, 
                        dataApplied: (action === drawerConfigs.drawerBtnTypes.SUBMIT ? true : false), 
                        dataReset: (action === drawerConfigs.drawerBtnTypes.RESET ? true : false),
                        submitBtnDisable: true, 
                        closeBtnDisable: false  
                    })}
                    style={{ width: '100%' }}
                    disabled={isbtndisable}
                >
                    {label}
                </Button>
            );
        }
    }

    useEffect(() => {
        setDrawerVisible(props.visible);
    }, [props.visible]);

    useEffect(() => {
        setDrawerData(props.data.bodyData);
    }, [props.data]);

    let buttonSection = [];
    let styledButtonSection = [];

    if (!_.isEmpty(props.closeCallback)) {
        buttonSection.push(processCallBackSections(props.closeCallback.type, props.closeCallback.label, props.closeCallback.isDisable, props.closeCallback.callback, props.closeCallback.actionType));
    }

    if (!_.isEmpty(props.submitCallback)) {
        buttonSection.push(processCallBackSections(props.submitCallback.type, props.submitCallback.label, props.submitCallback.isDisable, props.submitCallback.callback, props.submitCallback.actionType));
    }

    if (buttonSection.length > 0) {
        let colspan = 24 / buttonSection.length;
        for (const bs of buttonSection) {
            styledButtonSection.push(
                <Col
                    key={"col_" + bs.key}
                    span={colspan}>
                    {bs}
                </Col>);
        }
    }

    return (
        <Drawer
            key={props.name}
            title={props.title}
            placement={props.placement}
            onClose={() => props.closeCallback.callback({ visibility: false, dataApplied: false, dataReset: true, submitBtnDisable: true, closeBtnDisable: false })}
            visible={drawerVisible}
            zIndex={1052}
            width={props.width}
            className={props.className}
            maskClosable={props.data.type === drawerConfigs.drawerType.FILTER || props.data.type === drawerConfigs.drawerType.FORM ? false : true}
        >
            <Row gutter={[8, 8]} align="bottom">
                {
                    drawerData
                }
            </Row>
            {
                styledButtonSection.length !== 0 ?
                    <Row gutter={[16, 40]} align="bottom" style={{ marginTop: '20px' }}>{styledButtonSection}</Row> : ""
            }
        </Drawer>
    );
}

export default React.memo(CustomDrawer);